import { render } from "./RegistOneClassEduPay.vue?vue&type=template&id=693742f4"
import script from "./RegistOneClassEduPay.vue?vue&type=script&lang=js"
export * from "./RegistOneClassEduPay.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__